import {useSearchParams} from "react-router-dom";
import Profile from "../components/Profile";
import NotFound from "./NotFound";

const OtherProfile = () => {
    const [searchParams] = useSearchParams();
    const username = searchParams.get("username")

    if (!username) return <NotFound/>;

    // The key makes sure we start fresh when jumping from one profile to another
    return <Profile key={username} username={username} ownProfile={false}/>;
}

export default OtherProfile;
